import { Box, Card, Typography } from '@mui/material'
import React from 'react'

interface propTypes {
  name: string
  desc: string
  details: {
    title: string
    desc: string
  }[]
}

const GISSolutionsCard: React.FC<propTypes> = (props) => {
  const { name, desc, details } = props
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        width: { xs: '90%', md: '40%' },
        mb: 3,
        borderRadius: '12px',
        mx: 'auto',
      }}
      elevation={2}
    >
      <Box sx={{ width: '100%', p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <Typography variant="h4" fontWeight={500}>
            {name}
          </Typography>
          <Typography
            variant="h5"
            sx={{ ml: 1, display: { xs: 'none', md: 'initial' } }}
          >
            –
          </Typography>
          <Typography sx={{ ml: 1 }} variant="h5">
            {desc}
          </Typography>
        </Box>
        <Typography sx={{ mt: 4 }}>Capabilities:</Typography>
        {details.map((item, index) => (
          <Box sx={{ my: 1 }} key={index}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                ml: 2,
              }}
            >
              <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>
                {item.title}
              </Typography>
              <Typography
                sx={{ ml: 1, display: { xs: 'none', md: 'initial' } }}
              >
                –
              </Typography>
              <Typography sx={{ ml: 1 }}>{item.desc}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Card>
  )
}

export default GISSolutionsCard
